export interface Employee {
    name: string;
    role: string;
    image: string;
    linkedin: string;
}

export const employees: { department: string; data: Employee[]; styles: string }[] = [
    {
        department: 'Diretoria',
        styles: 'diretoria',
        data: [
            {
                name: 'Marcos Miranda',
                role: 'CEO',
                image: 'Marcos.Miranda.png',
                linkedin: 'https://www.linkedin.com/in/marcosmirandapro/',
            },
            {
                name: 'Marcelo Passos',
                role: 'Vice Presidente',
                image: 'Marcelo.Passos.png',
                linkedin: 'https://www.linkedin.com/in/mcpassos/',
            },
        ],
    },
    {
        department: 'Comercial',
        styles: 'comercial',
        data: [
            {
                name: 'Julio Junqueira',
                role: 'Vendas Sudeste',
                image: 'Julio.Junqueira.png',
                linkedin: 'https://www.linkedin.com/in/julio-junqueira-37a98813/',
            },
            {
                name: 'Rodrigo Lima',
                role: 'Vendas Nordeste / Centro Oeste',
                image: 'Rodrigo.Rego.png',
                linkedin: 'https://www.linkedin.com/in/rodrigo-l-b1b275168/',
            },
        ],
    },
    {
        department: 'Operações',
        styles: 'operacoes',
        data: [
            {
                name: 'Marcos Rabello',
                role: 'Gerencia de Operações',
                image: 'Marcos.Rabello.png',
                linkedin: 'https://www.linkedin.com/in/mrabello/',
            }, // substitua pelo seu nome e imagem
            {
                name: 'Kildane Castro',
                role: 'Operações Cibernéticas',
                image: 'Kildane.Castro.png',
                linkedin: 'https://www.linkedin.com/in/kildanecastro',
            },
            {
                name: 'Gilberto Ferreira',
                role: 'Operações Cibernéticas',
                image: 'Gilberto.Ferreira.png',
                linkedin: 'https://www.linkedin.com/in/gilbertocf10/',
            },
            {
                name: 'André Ouriques',
                role: 'Operações Cibernéticas',
                image: 'Andre.Moraes.png',
                linkedin: 'https://www.linkedin.com/in/andr%C3%A9-ouriques-01830914/',
            },
            {
                name: 'Luiz Januzzi',
                role: 'Coordenador de Infraestrutura',
                image: 'Luiz.Jannuzzi.png',
                linkedin: 'https://www.linkedin.com/in/luiz-jannuzzi-b620b339/',
            },
            {
                name: 'Julio Veras',
                role: 'Coordenador de Serviços',
                image: 'Julio.Neto.png',
                linkedin: 'https://www.linkedin.com/in/julio-veras-gerente-projetos/',
            }, // imagem não localizada
        ],
    },
];
